export default {
  //
  ['SET_VIEW'](state, payload) {
    state.view = payload
  },
  ['SET_PAGE'](state, payload) {
    state.page = payload
  },
  ['SET_LOGIN_STATUS'](state, payload) {
    state.isLogin = payload
  }
}
